import type { Membresia } from '../api/operaciones';
import { rolesDe } from '../logica/acceso';
import { iniciales, lineaNegocio } from '../logica/navegacion';

/** «Propietario · <dominio>/embrujo»: rol y `public_url` sin `https://` (G99, G118, G125). */
export function lineaDe(m: Membresia): string {
    return lineaNegocio(rolesDe(m), m.public_url);
}

export function inicialesDe(m: Membresia): string {
    return iniciales(m.business_name);
}
